// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"562":"f8306850","649":"20970dbd","705":"eeba1714","760":"28776884","787":"7f6b67cc","897":"dd237078"}[chunkId] + ".chunk.js";
};